export const VIEW_PAIDFEES_DETAILS = "VIEW_PAIDFEES_DETAILS"
export const VIEW_PAIDFEES_DETAILS_SUCCESS = "VIEW_PAIDFEES_DETAILS_SUCCESS"
export const VIEW_PAIDFEES_DETAILS_FAILED = "VIEW_PAIDFEES_DETAILS_FAILED"

export const PRINT_PAIDFEES_DETAILS = "PRINT_PAIDFEES_DETAILS"
export const PRINT_PAIDFEES_DETAILS_SUCCESS = "PRINT_PAIDFEES_DETAILS_SUCCESS"
export const PRINT_PAIDFEES_DETAILS_FAILED = "PRINT_PAIDFEES_DETAILS_FAILED"